import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { BOOKING_URL, SITE } from '../../data/site';
import { IMAGES } from '../../data/images';
import { ImageSlot } from '../ui/ImageSlot';
import { ButtonLink } from '../ui/ButtonLink';
import { StarDivider } from '../ui/StarDivider';
interface CtaBandProps {
  title?: React.ReactNode;
  sub?: string;
  primaryLabel?: string;
}
export function CtaBand({
  title = 'Your Safety. Your Responsibility. Start Today.',
  sub,
  primaryLabel = 'Book a Class'
}: CtaBandProps) {
  return <section className="relative isolate overflow-hidden bg-ink" aria-labelledby="cta-band-title" data-id="element-466" data-mp="2djpmc4ti2old">
      <ImageSlot image={IMAGES.rangeWide} decorative className="absolute inset-0 -z-10 opacity-70" data-id="element-467" data-mp="1zssz6ticezlp" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-ink/95 via-ink/75 to-midnight/50" aria-hidden="true" data-id="element-468" data-mp="24r45wvdcctzp" />
      <div className="gutter section flex flex-col items-start gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-469" data-mp="1pverpjeedl5j">
        <div data-id="element-470" data-mp="qqs2jdg6ugen">
          <StarDivider align="left" data-id="element-471" data-mp="qqibrnnbk57w" />
          <h2 id="cta-band-title" className="t-display mt-6 max-w-[16ch] text-[clamp(2.5rem,5.5vw,7rem)] text-white" data-id="element-472" data-mp="qpgxzbex54mh">
            {title}
          </h2>
          {sub && <p className="t-lead mt-5 max-w-[44rem] text-chrome-300" data-id="element-473" data-mp="zr6peh8sw3k9">{sub}</p>}
        </div>
        <div className="flex flex-wrap gap-3" data-id="element-474" data-mp="vpv60tgiseki">
          <ButtonLink href={BOOKING_URL} size="lg" data-id="element-475" data-mp="vr6bcxpm5udq">
            {primaryLabel}
          </ButtonLink>
          <ButtonLink href={SITE.phoneHref} size="lg" variant="outline-light" data-id="element-476" data-mp="80shr2rdrnh1">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-477" data-mp="328umz11w5n3" /> Call {SITE.phoneDisplay}
          </ButtonLink>
        </div>
      </div>
    </section>;
}